import { Flex, Heading, Link, Notice, Tag, Text } from "@applyboard/crystal-ui"
import { NavBars } from "../../../components/NavBars"
import { StudentApplication } from "../../../components/Application/types"
import { ChevronLeftOutlineIcon } from "@applyboard/ui-icons"
import { ApplicationSteps } from "../../../utils"
import { ProgramFilters } from "../ProgramFilters"
import { ProgramList } from "../ProgramList"
import { CampusInformation, ProgramInformation, ProgramIntakeTerm } from "@applyboard/school-applications-types-lib"
import { useNavigate } from "react-router-dom"

type SelectAlternateProgramProps = Readonly<{
  application: StudentApplication | null
  isUpdatingApplication: boolean
  temporaryApplication?: StudentApplication | null
  setTemporaryApplication: (application: StudentApplication) => void
  setCurrentStep: (step: ApplicationSteps) => void
  handleUpdateApplication: (programIntakeId: string | null, alternateProgramId?: string[]) => void
  currentApplicationId: string
}>

export function SelectAlternateProgram(props: SelectAlternateProgramProps) {
  const navigate = useNavigate()

  const alternateProgramSelected = (props.application?.attributes?.alternateProgramSelected ?? []).find(alternateProgram => alternateProgram.programIntakeId)

  return (
    <NavBars largePage>
      <Flex gap={6} direction="column">
        <Text>
          <Link
            href={props.application ? `/applications/${props.currentApplicationId}` : '/applications/new'}
            leadIcon={ChevronLeftOutlineIcon}
            variant="standalone"
          >
            {props.application ? 'Back to current application' : 'Back to Program selection'}
          </Link>
        </Text>
        <Flex align={{ xs: 'start', md: 'center'}} direction={{ xs: 'column', md: 'row'}} gap={4}>
          <Heading level={1} variant="headlineL">
            Alternate Program
          </Heading>
          <Tag intent="secondary">Optional</Tag>
        </Flex>

        <Notice intent="secondary">
          <Text>Adding an alternate program may increase your chances of admission.</Text>
          <Notice.Button
            loading={props.isUpdatingApplication}
            onClick={() => {
              if (!props.application) {
                props.setTemporaryApplication({
                  ...props.temporaryApplication,
                  attributes: {
                    ...props.temporaryApplication?.attributes,
                    alternateProgramSelected: [],
                  },
                } as StudentApplication)

                props.setCurrentStep(ApplicationSteps.PERSONAL_INFORMATION)
                navigate(`/applications/new`, { replace: true })
              } else {
                props.handleUpdateApplication(null, [])
              }
            }}
          >
            Skip this step
          </Notice.Button>
        </Notice>

        <ProgramFilters />
        <ProgramList
          hideConfirmationDialog
          loading={props.isUpdatingApplication}
          onSubmit={intake => {
            if (!props.application) {
              props.setTemporaryApplication({
                ...props.temporaryApplication,
                attributes: {
                  ...props.temporaryApplication?.attributes,
                  alternateProgramSelected: [{
                    programIntakeId: intake?.id,
                    program: intake?.attributes?.program as ProgramInformation,
                    programIntakeTerm: {
                      id: intake?.attributes?.intakeTerm?.id,
                      name: intake?.attributes?.intakeTerm?.name,
                      startDate: intake?.attributes?.intakeTerm?.startsOn,
                    } as ProgramIntakeTerm,
                    campus: intake?.attributes?.campus as CampusInformation,
                  }],
                },
              } as StudentApplication)

              props.setCurrentStep(ApplicationSteps.PERSONAL_INFORMATION)
              navigate(`/applications/new`, { replace: true })
            } else {
              props.handleUpdateApplication(null, [intake.id])
            }
          }}
          currentApplication={props.application?.attributes}
          primarySelectedProgramId={props.application?.attributes?.programSelected?.programIntakeId ?? props.temporaryApplication?.attributes?.programSelected?.programIntakeId}
          alternateProgramSelected={alternateProgramSelected?.programIntakeId}
        />
      </Flex>
    </NavBars>
  )
}
